package com.eladfinish.bible.contest

import dev.icerock.moko.resources.ImageResource
import kotlin.collections.List

internal object CommonMainImages0 {
  internal val background_parchment: ImageResource by lazy { init_background_parchment() }

  internal val bg_overflow_menu: ImageResource by lazy { init_bg_overflow_menu() }

  internal val btn_normal: ImageResource by lazy { init_btn_normal() }

  internal val btn_shadow: ImageResource by lazy { init_btn_shadow() }

  internal val dice3d: ImageResource by lazy { init_dice3d() }

  internal val dice3droll: ImageResource by lazy { init_dice3droll() }

  internal val dice_1: ImageResource by lazy { init_dice_1() }

  internal val dice_2: ImageResource by lazy { init_dice_2() }

  internal val dice_3: ImageResource by lazy { init_dice_3() }

  internal val dice_4: ImageResource by lazy { init_dice_4() }

  internal val dice_5: ImageResource by lazy { init_dice_5() }

  internal val dice_6: ImageResource by lazy { init_dice_6() }

  internal val ic_answer_correct: ImageResource by lazy { init_ic_answer_correct() }

  internal val ic_answer_wrong: ImageResource by lazy { init_ic_answer_wrong() }

  internal val ic_arrow_back: ImageResource by lazy { init_ic_arrow_back() }

  internal val ic_arrow_down: ImageResource by lazy { init_ic_arrow_down() }

  internal val ic_arrow_drop_down: ImageResource by lazy { init_ic_arrow_drop_down() }

  internal val ic_arrow_folder_open: ImageResource by lazy { init_ic_arrow_folder_open() }

  internal val ic_arrow_forward: ImageResource by lazy { init_ic_arrow_forward() }

  internal val ic_arrow_right_bold_circle: ImageResource by lazy { init_ic_arrow_right_bold_circle()
      }

  internal val ic_auto_renew: ImageResource by lazy { init_ic_auto_renew() }

  internal val ic_back: ImageResource by lazy { init_ic_back() }

  internal val ic_blank: ImageResource by lazy { init_ic_blank() }

  internal val ic_bookmark: ImageResource by lazy { init_ic_bookmark() }

  internal val ic_bookmark_check: ImageResource by lazy { init_ic_bookmark_check() }

  internal val ic_button_drag: ImageResource by lazy { init_ic_button_drag() }

  internal val ic_chart_bar_stacked_black: ImageResource by lazy { init_ic_chart_bar_stacked_black()
      }

  internal val ic_chat_bubble_with_quotation_marks: ImageResource by lazy {
      init_ic_chat_bubble_with_quotation_marks() }

  internal val ic_checkbox_blank_outline: ImageResource by lazy { init_ic_checkbox_blank_outline() }

  internal val ic_checkbox_marked: ImageResource by lazy { init_ic_checkbox_marked() }

  internal val ic_checkbox_multiple_blank_outline: ImageResource by lazy {
      init_ic_checkbox_multiple_blank_outline() }

  internal val ic_checkbox_multiple_marked: ImageResource by lazy {
      init_ic_checkbox_multiple_marked() }

  internal val ic_close: ImageResource by lazy { init_ic_close() }

  internal val ic_close_circle: ImageResource by lazy { init_ic_close_circle() }

  internal val ic_copy: ImageResource by lazy { init_ic_copy() }

  internal val ic_copy_white: ImageResource by lazy { init_ic_copy_white() }

  internal val ic_credit_card: ImageResource by lazy { init_ic_credit_card() }

  internal val ic_delete_black: ImageResource by lazy { init_ic_delete_black() }

  internal val ic_donation: ImageResource by lazy { init_ic_donation() }

  internal val ic_error_black: ImageResource by lazy { init_ic_error_black() }

  internal val ic_file_document: ImageResource by lazy { init_ic_file_document() }

  internal val ic_filter_black: ImageResource by lazy { init_ic_filter_black() }

  internal val ic_format_list_bulleted_type: ImageResource by lazy {
      init_ic_format_list_bulleted_type() }

  internal val ic_format_list_numbers: ImageResource by lazy { init_ic_format_list_numbers() }

  internal val ic_format_size: ImageResource by lazy { init_ic_format_size() }

  internal val ic_green_tick: ImageResource by lazy { init_ic_green_tick() }

  internal val ic_help: ImageResource by lazy { init_ic_help() }

  internal val ic_keyboard_arrow_left_black: ImageResource by lazy {
      init_ic_keyboard_arrow_left_black() }

  internal val ic_keyboard_arrow_right_black: ImageResource by lazy {
      init_ic_keyboard_arrow_right_black() }

  internal val ic_launcher_shared: ImageResource by lazy { init_ic_launcher_shared() }

  internal fun values(): List<ImageResource> = listOf(background_parchment, bg_overflow_menu,
      btn_normal, btn_shadow, dice3d, dice3droll, dice_1, dice_2, dice_3, dice_4, dice_5, dice_6,
      ic_answer_correct, ic_answer_wrong, ic_arrow_back, ic_arrow_down, ic_arrow_drop_down,
      ic_arrow_folder_open, ic_arrow_forward, ic_arrow_right_bold_circle, ic_auto_renew, ic_back,
      ic_blank, ic_bookmark, ic_bookmark_check, ic_button_drag, ic_chart_bar_stacked_black,
      ic_chat_bubble_with_quotation_marks, ic_checkbox_blank_outline, ic_checkbox_marked,
      ic_checkbox_multiple_blank_outline, ic_checkbox_multiple_marked, ic_close, ic_close_circle,
      ic_copy, ic_copy_white, ic_credit_card, ic_delete_black, ic_donation, ic_error_black,
      ic_file_document, ic_filter_black, ic_format_list_bulleted_type, ic_format_list_numbers,
      ic_format_size, ic_green_tick, ic_help, ic_keyboard_arrow_left_black,
      ic_keyboard_arrow_right_black, ic_launcher_shared)
}

private fun init_background_parchment(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/background_parchment.png\")") as String, fileName =
    "background_parchment.png")

private fun init_bg_overflow_menu(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/bg_overflow_menu.svg\")") as String, fileName = "bg_overflow_menu.svg")

private fun init_btn_normal(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/btn_normal.png\")") as String, fileName = "btn_normal.png")

private fun init_btn_shadow(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/btn_shadow.png\")") as String, fileName = "btn_shadow.png")

private fun init_dice3d(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/dice3d.png\")") as String, fileName = "dice3d.png")

private fun init_dice3droll(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/dice3droll.png\")") as String, fileName = "dice3droll.png")

private fun init_dice_1(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/dice_1.png\")") as String, fileName = "dice_1.png")

private fun init_dice_2(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/dice_2.png\")") as String, fileName = "dice_2.png")

private fun init_dice_3(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/dice_3.png\")") as String, fileName = "dice_3.png")

private fun init_dice_4(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/dice_4.png\")") as String, fileName = "dice_4.png")

private fun init_dice_5(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/dice_5.png\")") as String, fileName = "dice_5.png")

private fun init_dice_6(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/dice_6.png\")") as String, fileName = "dice_6.png")

private fun init_ic_answer_correct(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_answer_correct.svg\")") as String, fileName = "ic_answer_correct.svg")

private fun init_ic_answer_wrong(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_answer_wrong.svg\")") as String, fileName = "ic_answer_wrong.svg")

private fun init_ic_arrow_back(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_arrow_back.svg\")") as String, fileName = "ic_arrow_back.svg")

private fun init_ic_arrow_down(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_arrow_down.svg\")") as String, fileName = "ic_arrow_down.svg")

private fun init_ic_arrow_drop_down(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_arrow_drop_down.svg\")") as String, fileName =
    "ic_arrow_drop_down.svg")

private fun init_ic_arrow_folder_open(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_arrow_folder_open.svg\")") as String, fileName =
    "ic_arrow_folder_open.svg")

private fun init_ic_arrow_forward(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_arrow_forward.svg\")") as String, fileName = "ic_arrow_forward.svg")

private fun init_ic_arrow_right_bold_circle(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_arrow_right_bold_circle.svg\")") as String, fileName =
    "ic_arrow_right_bold_circle.svg")

private fun init_ic_auto_renew(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_auto_renew.svg\")") as String, fileName = "ic_auto_renew.svg")

private fun init_ic_back(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_back.svg\")") as String, fileName = "ic_back.svg")

private fun init_ic_blank(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_blank.png\")") as String, fileName = "ic_blank.png")

private fun init_ic_bookmark(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_bookmark.svg\")") as String, fileName = "ic_bookmark.svg")

private fun init_ic_bookmark_check(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_bookmark_check.svg\")") as String, fileName = "ic_bookmark_check.svg")

private fun init_ic_button_drag(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_button_drag.svg\")") as String, fileName = "ic_button_drag.svg")

private fun init_ic_chart_bar_stacked_black(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_chart_bar_stacked_black.svg\")") as String, fileName =
    "ic_chart_bar_stacked_black.svg")

private fun init_ic_chat_bubble_with_quotation_marks(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_chat_bubble_with_quotation_marks.svg\")") as String, fileName =
    "ic_chat_bubble_with_quotation_marks.svg")

private fun init_ic_checkbox_blank_outline(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_checkbox_blank_outline.svg\")") as String, fileName =
    "ic_checkbox_blank_outline.svg")

private fun init_ic_checkbox_marked(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_checkbox_marked.svg\")") as String, fileName =
    "ic_checkbox_marked.svg")

private fun init_ic_checkbox_multiple_blank_outline(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_checkbox_multiple_blank_outline.svg\")") as String, fileName =
    "ic_checkbox_multiple_blank_outline.svg")

private fun init_ic_checkbox_multiple_marked(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_checkbox_multiple_marked.svg\")") as String, fileName =
    "ic_checkbox_multiple_marked.svg")

private fun init_ic_close(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_close.svg\")") as String, fileName = "ic_close.svg")

private fun init_ic_close_circle(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_close_circle.svg\")") as String, fileName = "ic_close_circle.svg")

private fun init_ic_copy(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_copy.svg\")") as String, fileName = "ic_copy.svg")

private fun init_ic_copy_white(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_copy_white.svg\")") as String, fileName = "ic_copy_white.svg")

private fun init_ic_credit_card(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_credit_card.svg\")") as String, fileName = "ic_credit_card.svg")

private fun init_ic_delete_black(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_delete_black.svg\")") as String, fileName = "ic_delete_black.svg")

private fun init_ic_donation(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_donation.svg\")") as String, fileName = "ic_donation.svg")

private fun init_ic_error_black(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_error_black.svg\")") as String, fileName = "ic_error_black.svg")

private fun init_ic_file_document(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_file_document.svg\")") as String, fileName = "ic_file_document.svg")

private fun init_ic_filter_black(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_filter_black.svg\")") as String, fileName = "ic_filter_black.svg")

private fun init_ic_format_list_bulleted_type(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_format_list_bulleted_type.svg\")") as String, fileName =
    "ic_format_list_bulleted_type.svg")

private fun init_ic_format_list_numbers(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_format_list_numbers.svg\")") as String, fileName =
    "ic_format_list_numbers.svg")

private fun init_ic_format_size(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_format_size.svg\")") as String, fileName = "ic_format_size.svg")

private fun init_ic_green_tick(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_green_tick.svg\")") as String, fileName = "ic_green_tick.svg")

private fun init_ic_help(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_help.svg\")") as String, fileName = "ic_help.svg")

private fun init_ic_keyboard_arrow_left_black(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_keyboard_arrow_left_black.svg\")") as String, fileName =
    "ic_keyboard_arrow_left_black.svg")

private fun init_ic_keyboard_arrow_right_black(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_keyboard_arrow_right_black.svg\")") as String, fileName =
    "ic_keyboard_arrow_right_black.svg")

private fun init_ic_launcher_shared(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_launcher_shared.png\")") as String, fileName =
    "ic_launcher_shared.png")

public actual val SharedRes.images.background_parchment: ImageResource
  get() = CommonMainImages0.background_parchment

public actual val SharedRes.images.bg_overflow_menu: ImageResource
  get() = CommonMainImages0.bg_overflow_menu

public actual val SharedRes.images.btn_normal: ImageResource
  get() = CommonMainImages0.btn_normal

public actual val SharedRes.images.btn_shadow: ImageResource
  get() = CommonMainImages0.btn_shadow

public actual val SharedRes.images.dice3d: ImageResource
  get() = CommonMainImages0.dice3d

public actual val SharedRes.images.dice3droll: ImageResource
  get() = CommonMainImages0.dice3droll

public actual val SharedRes.images.dice_1: ImageResource
  get() = CommonMainImages0.dice_1

public actual val SharedRes.images.dice_2: ImageResource
  get() = CommonMainImages0.dice_2

public actual val SharedRes.images.dice_3: ImageResource
  get() = CommonMainImages0.dice_3

public actual val SharedRes.images.dice_4: ImageResource
  get() = CommonMainImages0.dice_4

public actual val SharedRes.images.dice_5: ImageResource
  get() = CommonMainImages0.dice_5

public actual val SharedRes.images.dice_6: ImageResource
  get() = CommonMainImages0.dice_6

public actual val SharedRes.images.ic_answer_correct: ImageResource
  get() = CommonMainImages0.ic_answer_correct

public actual val SharedRes.images.ic_answer_wrong: ImageResource
  get() = CommonMainImages0.ic_answer_wrong

public actual val SharedRes.images.ic_arrow_back: ImageResource
  get() = CommonMainImages0.ic_arrow_back

public actual val SharedRes.images.ic_arrow_down: ImageResource
  get() = CommonMainImages0.ic_arrow_down

public actual val SharedRes.images.ic_arrow_drop_down: ImageResource
  get() = CommonMainImages0.ic_arrow_drop_down

public actual val SharedRes.images.ic_arrow_folder_open: ImageResource
  get() = CommonMainImages0.ic_arrow_folder_open

public actual val SharedRes.images.ic_arrow_forward: ImageResource
  get() = CommonMainImages0.ic_arrow_forward

public actual val SharedRes.images.ic_arrow_right_bold_circle: ImageResource
  get() = CommonMainImages0.ic_arrow_right_bold_circle

public actual val SharedRes.images.ic_auto_renew: ImageResource
  get() = CommonMainImages0.ic_auto_renew

public actual val SharedRes.images.ic_back: ImageResource
  get() = CommonMainImages0.ic_back

public actual val SharedRes.images.ic_blank: ImageResource
  get() = CommonMainImages0.ic_blank

public actual val SharedRes.images.ic_bookmark: ImageResource
  get() = CommonMainImages0.ic_bookmark

public actual val SharedRes.images.ic_bookmark_check: ImageResource
  get() = CommonMainImages0.ic_bookmark_check

public actual val SharedRes.images.ic_button_drag: ImageResource
  get() = CommonMainImages0.ic_button_drag

public actual val SharedRes.images.ic_chart_bar_stacked_black: ImageResource
  get() = CommonMainImages0.ic_chart_bar_stacked_black

public actual val SharedRes.images.ic_chat_bubble_with_quotation_marks: ImageResource
  get() = CommonMainImages0.ic_chat_bubble_with_quotation_marks

public actual val SharedRes.images.ic_checkbox_blank_outline: ImageResource
  get() = CommonMainImages0.ic_checkbox_blank_outline

public actual val SharedRes.images.ic_checkbox_marked: ImageResource
  get() = CommonMainImages0.ic_checkbox_marked

public actual val SharedRes.images.ic_checkbox_multiple_blank_outline: ImageResource
  get() = CommonMainImages0.ic_checkbox_multiple_blank_outline

public actual val SharedRes.images.ic_checkbox_multiple_marked: ImageResource
  get() = CommonMainImages0.ic_checkbox_multiple_marked

public actual val SharedRes.images.ic_close: ImageResource
  get() = CommonMainImages0.ic_close

public actual val SharedRes.images.ic_close_circle: ImageResource
  get() = CommonMainImages0.ic_close_circle

public actual val SharedRes.images.ic_copy: ImageResource
  get() = CommonMainImages0.ic_copy

public actual val SharedRes.images.ic_copy_white: ImageResource
  get() = CommonMainImages0.ic_copy_white

public actual val SharedRes.images.ic_credit_card: ImageResource
  get() = CommonMainImages0.ic_credit_card

public actual val SharedRes.images.ic_delete_black: ImageResource
  get() = CommonMainImages0.ic_delete_black

public actual val SharedRes.images.ic_donation: ImageResource
  get() = CommonMainImages0.ic_donation

public actual val SharedRes.images.ic_error_black: ImageResource
  get() = CommonMainImages0.ic_error_black

public actual val SharedRes.images.ic_file_document: ImageResource
  get() = CommonMainImages0.ic_file_document

public actual val SharedRes.images.ic_filter_black: ImageResource
  get() = CommonMainImages0.ic_filter_black

public actual val SharedRes.images.ic_format_list_bulleted_type: ImageResource
  get() = CommonMainImages0.ic_format_list_bulleted_type

public actual val SharedRes.images.ic_format_list_numbers: ImageResource
  get() = CommonMainImages0.ic_format_list_numbers

public actual val SharedRes.images.ic_format_size: ImageResource
  get() = CommonMainImages0.ic_format_size

public actual val SharedRes.images.ic_green_tick: ImageResource
  get() = CommonMainImages0.ic_green_tick

public actual val SharedRes.images.ic_help: ImageResource
  get() = CommonMainImages0.ic_help

public actual val SharedRes.images.ic_keyboard_arrow_left_black: ImageResource
  get() = CommonMainImages0.ic_keyboard_arrow_left_black

public actual val SharedRes.images.ic_keyboard_arrow_right_black: ImageResource
  get() = CommonMainImages0.ic_keyboard_arrow_right_black

public actual val SharedRes.images.ic_launcher_shared: ImageResource
  get() = CommonMainImages0.ic_launcher_shared
